import { HttpClient, HttpHeaders } from "@angular/common/http";
import { EventEmitter, Injectable, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { ICvxClaimsPrincipal } from '@cvx/cal-angular';
import { SelectionEvent } from "@progress/kendo-angular-grid";
import { NotificationRef, NotificationService } from '@progress/kendo-angular-notification';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CustomNotificationComponent } from "../features/common/custom-notification/custom-notification.component";
import { DataPointDto, DataPointGraphModel } from "../features/reportingdashboard/model/data-point-graph.model";
import saveAs from "file-saver";
import { Title } from "@angular/platform-browser";

@Injectable({
  providedIn: 'root',
})
export class commonService {
  Name: string = '';
  teuBarColor = "rgb(0, 130, 200)";
  apiUrl = environment.apiUrl;
  commonAcceptedFiles: string[] = ['.pdf', '.csv', '.xls', '.xlsx', '.jpg', '.png', '.doc', '.msg', '.txt', '.docx','.zip'];
  fullName: string = '';
  userInfoManagement: any;
  fileSizeError: string = 'Unable to upload file: Maximum file size is 10MB.';
  userInfo: ICvxClaimsPrincipal | undefined;
  httpOptions: any = ""
  token = ""
  isSpecialist = new BehaviorSubject<boolean>(false);
  isAdmin = new BehaviorSubject<boolean>(false);
  userRoleAdded = new BehaviorSubject<boolean>(false);
  defaultDropdownItem = {
    id: 0,
    label: 'Select option'
  };

  prevNotificationMessage: string = '';
  prevNotificationType: string = '';
  prevNotification: NotificationRef | null = null;
  prevNotificationCanCloseByNavigation: boolean = false;

  userIsActive = new BehaviorSubject<boolean | null>(null);

  constructor(
    private notificationService: NotificationService,
    private http: HttpClient, private route: ActivatedRoute, private router: Router,
    private titleService: Title
  ) {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`,
        'Content-Type': 'application/json'
      })
    };

    if ("specialist" in sessionStorage) {
      this.isSpecialist.next(this.isUserSpecialist());
    }

    if ("admin" in sessionStorage) {
      this.isAdmin.next(this.isUserAdmin());
    }
  }

  getCurrentUTCDateTime(): string {
    const now = new Date();
    const year = now.getUTCFullYear();
    const month = String(now.getUTCMonth() + 1).padStart(2, '0');
    const day = String(now.getUTCDate()).padStart(2, '0');
    const hours = String(now.getUTCHours()).padStart(2, '0');
    const minutes = String(now.getUTCMinutes()).padStart(2, '0');
    const seconds = String(now.getUTCSeconds()).padStart(2, '0');

    return `${year}${month}${day}${hours}${minutes}${seconds}`;
  }

  async getRoleStatusData(): Promise<any> {
    return await firstValueFrom(this.getUserManagement()).then(async response => {
      this.userInfoManagement = response;
      if (this.userInfoManagement) {
        sessionStorage.setItem('userId', this.userInfoManagement.id);
        sessionStorage.setItem('userName', this.userInfoManagement.name);
        sessionStorage.setItem('userIsActive', this.userInfoManagement.isActive);
        sessionStorage.setItem('userEmail', this.userInfoManagement.email.toLowerCase());
        sessionStorage.setItem('userRoles', JSON.stringify(this.userInfoManagement.roles.map((x: any) => x.roleName)));

        let errorCount: any = 100;
        // sessionStorage.setItem('showErrorCount', errorCount);
        let validateMWOExist: any = true; //make it as true to validate MWO exist
        sessionStorage.setItem('shouldValidateMWOExist', validateMWOExist);

        // let specialist = this.userInfoManagement.roles.find((data: any) => data.id == 18 ) != undefined;
        // let specialist = this.userInfoManagement.roles.find((data: any) => data.id == 12 ) != undefined; SPECIALIST
        if(  this.userInfoManagement.roles.length > 0) {
        let specialist = this.userInfoManagement.roles.find((data: any) => data.roleName.toLocaleLowerCase() == "specialist" ) != undefined;
        this.isSpecialist.next(specialist);
        sessionStorage.setItem('specialist', specialist as unknown as string);

        // let admin = this.userInfoManagement.roles.find((data: any) => data.id == 19 ) != undefined;
        // let admin = this.userInfoManagement.roles.find((data: any) => data.id == 13 ) != undefined;
        let admin = this.userInfoManagement.roles.find((data: any) => data.roleName.toLocaleLowerCase() == "admin" ) != undefined;
        // let admin = this.userInfoManagement.isAdmin;
        this.isAdmin.next(admin);
        sessionStorage.setItem('admin', admin as unknown as string);
        }
        if(!this.userInfoManagement.isActive){
          this.router.navigate(['invalid-permission']);
        }
      }

      return this.userInfoManagement;
    }).catch((x: any) => {
      return {
        id: 0,
        name: '',
        isActive: false,
        email: '',
        roles: []
      };
    });
  }

  isUserSpecialist() {
    let roles = JSON.parse(sessionStorage.getItem('userRoles') ?? '[]');
    return roles.includes('SPECIALIST') ;
  }
  isUserAdmin() {
    let roles = JSON.parse(sessionStorage.getItem('userRoles') ?? '[]');
    return roles.includes('ADMIN') ;
  }

  isValidFileSize(uploadFileSize: number) {
    let maxFileSize = 10485760;
    if (uploadFileSize < maxFileSize) {
      return true;
    } else {
      return false;
    }
  }
  getFileType(type: string) {
    switch (type) {
      case 'txt':
        return "text/plain";
      case 'pdf':
        return "application/pdf";
      case 'jpg':
        return "image/jpeg";
      case 'jpeg':
        return "image/jpeg";
      case 'json':
        return "application/json";
      case 'png':
        return "image/png";
      case 'xls':
        return "application/vnd.ms-excel";
      case 'xlsx':
        return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      case 'xml':
        return "application/xml";
      case 'doc':
        return "application/msword";
      case 'docx':
        return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      case 'csv':
        return "text/csv";
      default:
        return "";
    }
  }

  isValidFile(file: File, fileList: string[]): boolean {
    let splitArray = file.name.split('.');
    let extension = '.' + splitArray[splitArray.length - 1];
    return fileList.includes(extension.toLocaleLowerCase());
  }

  public getUserManagement() {
    return this.http.get<any>(`${this.apiUrl}UserManagement`, this.httpOptions);
  }

  public onGridSelection(selectedIds: any, event: SelectionEvent, field: string = "") {
    if (event.selectedRows && event.selectedRows.length > 0) {
      event.selectedRows.forEach((row) => {
        if (field == "")
          selectedIds.add(row.index);
        else {
          if (row.dataItem[field]) {
            selectedIds.add(row.dataItem[field]);
          }
        }
      }
      );
    }

    if (event.deselectedRows && event.deselectedRows.length > 0) {
      event.deselectedRows.forEach((row) => {
        if (field == "")
          selectedIds.delete(row.index);
        else {
          if (row.dataItem[field]) {
            selectedIds.delete(row.dataItem[field]);
          }
        }
      });
    }

    return selectedIds;
  }

  public JopPlanSelectionGrid(selectedIds: any, event: SelectionEvent, field: string = "", selectionField: string = '') {
    if (event.selectedRows && event.selectedRows.length > 0) {
      event.selectedRows.forEach((row) => {
        if (field == "")
          selectedIds.add(row.index);
        else {
          if (row.dataItem[field]) {
            selectedIds.add(row.dataItem[selectionField]);
          }
        }
      }
      );
    }

    if (event.deselectedRows && event.deselectedRows.length > 0) {
      event.deselectedRows.forEach((row) => {
        if (field == "")
          selectedIds.delete(row.index);
        else {
          if (row.dataItem[field]) {
            selectedIds.delete(row.dataItem[selectionField]);
          }
        }
      });
    }

    return selectedIds;
  }

  updateQueryParams(paramKey: string, paramValue: any, secondParamKey: any = '', secondParamValue: any = ''): void {
    const queryParams = { [paramKey]: paramValue };

    if (secondParamKey != '') {
      queryParams[secondParamKey] = secondParamValue;
    }
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: 'merge' // Merge with existing query params 
    });
  }


  resetDateTime(date: any): Date {
    date = (date == undefined || date == "") ? new Date() : date;
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)
  }

  setACDID(action: string): number {
    action = action.toLocaleLowerCase();

    if (action === 'add')
      return 1;
    else if (action === 'delete')
      return 2;
    else if (action === 'change')
      return 3;
    else if (action === 'no change')
      return 4;

    return 0;
  }

  setACDAction(action: number): string {

    if (action === 1)
      return 'Add';
    else if (action === 2)
      return 'Delete';
    else if (action === 3)
      return 'Change';
    else if (action === 4)
      return 'No change';

    return '';
  }


  showNotificationMessage(messageText: string,
    messageType: 'none' | 'success' | 'warning' | 'error' | 'info',
    position: 'left' | 'center' | 'right', _duration?: number, canCloseByNav: boolean = true) {

    //if same error 
    if (messageText) {
      if (this.prevNotification != null) {
        this.prevNotification.hide();
      }

      let notification = this.notificationService.show({
        content: CustomNotificationComponent,
        cssClass: 'mt-20 notification-msg-status',
        animation: { type: 'slide', duration: _duration ? _duration : 200 },
        position: { horizontal: position, vertical: 'top' },
        type: { style: messageType, icon: true },
        closable: true
      });

      if (notification.content) {
        notification.content.instance.content = messageText;
      }

      if (messageType != "error" && messageType != "warning")
        this.notfificationHide(notification);

      this.prevNotificationMessage = messageText;
      this.prevNotificationType = messageType;
      this.prevNotification = notification;
      this.prevNotificationCanCloseByNavigation = canCloseByNav;
    }
  }

  private notfificationHide(notification: any, timeOut: number = 10000) {
    setTimeout(() => {
      notification.hide();
    }, timeOut);
  }

  prepareChartData(response: DataPointDto[], type: string = '', customToolTip: boolean = false): DataPointGraphModel[] {
    response = this.toolTip_ColorSet(response, type, customToolTip);
    let list: DataPointGraphModel[] = [];
    let seriesNameList = response?.map((x: DataPointDto) => x.dataSeriesName);

    seriesNameList = [...new Set(seriesNameList)];

    seriesNameList.forEach((x: string) => {
      let seriesData = response?.filter((y: DataPointDto) => y.value >= 0 && x == y.dataSeriesName);
      list.push({ name: x, type: type, data: seriesData });
    });

    return list;
  }

  private toolTip_ColorSet(response: any, type: string = '', customToolTip: boolean = false): any {
    response?.forEach((x: DataPointDto) => {
      x.finalValue = `${x.value}${type == 'column' ? '%' : ''}`;
      if (customToolTip) {
        x.tooltip = `${x.dataSeriesName},${x.label}:${x.finalValue}`;
      }
      else {
        x.tooltip = x.finalValue;
      }
    });

    return response;
  }

  downloadFile(file: Blob, fileName: string) {
    saveAs(file, fileName);
  }

  isUserAccesible(userId: number, onBehalfId: number) {

    let locUserId: any = sessionStorage.getItem('userId')
    let loginUserId: number = JSON.parse(locUserId)
     const specialist = JSON.stringify(JSON.parse(sessionStorage.getItem('specialist') ?? ''));
    if (loginUserId == userId || loginUserId == onBehalfId || specialist == 'true') {
      return true;
    }
    return false;
  }
  styleApplyForNonAccessUser(renderer: Renderer2, isUserHaveAccess: boolean,
    buildIds: string[], enabledIds: string[], disabledCssEffetcIds: string[]) {
    let userRoles = JSON.parse(sessionStorage.getItem('userRoles') || '[]');

    userRoles = userRoles.map((x: string) => x = x.toLocaleLowerCase());

    let viewElement = document.getElementById('allBuildViews');

    if (viewElement != null && !isUserHaveAccess && !userRoles.includes('admin')) {

      let dropDownList = viewElement.querySelectorAll('kendo-dropdownlist');
      dropDownList.forEach(button => {
        renderer.addClass(button, 'k-disabled');
      });

      buildIds.forEach((buildId: string) => {
        let inputSpinner = document.getElementById(buildId)?.getElementsByClassName('k-input-spinner');
        if (inputSpinner && inputSpinner.length > 0) {
          for (let index = 0; index < inputSpinner.length; index++) {
            let element = inputSpinner[index];
            renderer.setStyle(element, 'display', 'none');
          }
        }
      });

      let buttons = viewElement.querySelectorAll('button');
      buttons.forEach(button => {
        if (!button.classList.contains('k-input-button')) {
          if (!(button.classList.contains('k-spinner-increase') || button.classList.contains('k-spinner-decrease'))) {
            if (!enabledIds.includes(button.id)) {
              renderer.setAttribute(button, 'disabled', 'true');
            }

            if (!disabledCssEffetcIds.includes(button.id)) {
              renderer.addClass(button, 'btn-disabled2');
            }

            if (button.id == "clearAllInBuild") {
              renderer.addClass(button, 'clearAll-Disabled');
            }
          } else {
            renderer.setStyle(button, 'pointer-events', 'none');
          }
        }
      });

      let inputElements = viewElement.querySelectorAll('input');
      inputElements.forEach(inputElement => {
        if (!enabledIds.includes(inputElement.id)) {
          renderer.addClass(inputElement, 'input-disabled');
        }
      });

      buildIds.forEach((buildId: string) => {
        let gridElement = document.getElementById(buildId);

        if (gridElement) {
          let iconElements = gridElement.querySelectorAll('fa-icon');
          iconElements.forEach(iconElement => {
            if (!enabledIds.includes(iconElement.id)) {
              renderer.setStyle(iconElement.parentElement, 'pointer-events', 'none');
              renderer.removeClass(iconElement, "bluePrimary");
              renderer.addClass(iconElement, "icon-disabled");
            }
          });
        }
      });
    }
  }

  deepClone(obj: any): any {
    // Check if the value is an object or a Date instance
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }

    if (obj instanceof Date) {
      return new Date(obj.getTime()); // Clone Date instance
    }

    // Handle arrays
    if (Array.isArray(obj)) {
      return obj.map(item => this.deepClone(item));
    }

    // Handle objects
    const clonedObj: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        clonedObj[key] = this.deepClone(obj[key]);
      }
    }

    return clonedObj;
  }

  formatDateToReviewFormat(date: any) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `Review-${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
  }

  extractFilename(contentDisposition: string | null): string {
    const filenameRegex = /filename[^;=\n]*=(['"]?)([^;\n]*)\1/;
    const matches = filenameRegex.exec(contentDisposition || '');
    return matches ? matches[2] : 'default-filename.zip';
  }

  setPageTitle(title: any) {
    this.titleService.setTitle(title);
  }
}